import React from 'react';

import { useTheme } from '@mui/material/styles';

function ColorsIcon({ isActive }) {
    const theme = useTheme();

    const color = isActive ? theme.palette.primary.main : theme.palette.icons.color;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <rect width={7} height={16} x={4} y={4} stroke={color} strokeWidth={2} rx={1} />
            <path stroke={color} strokeWidth={2} d="m11 9.274 4.148-3.545c.454-.389 1.194-.345 1.584.094l2.71 3.05a.845.845 0 0 1-.061 1.207L11 17.936" />
            <path stroke={color} strokeWidth={2} d="M16 13h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-9" />
            <circle cx={7.5} cy={16.5} r={1.5} fill={color} />
        </svg>
    );
}

export default ColorsIcon;
